import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { ValidatedResponse } from '../../shared/models/validated-response.model';
import { IncidentSearchCriteria } from '../models/incident-search-criteria.model';
import { IncidentModel } from '../models/incident.model';
// TODO: Remove dependency on jquery
import * as $ from 'jquery';

export abstract class IncidentServiceBase<TModel extends IncidentModel> extends BaseApiService {
    private _entityName: string;
    private _entityCreator: () => TModel;

    constructor(entityName: string, entityCreator: () => TModel) {
        super();
        this._entityName = entityName;
        this._entityCreator = entityCreator;
    }

    public getIncident(incidentId: number): Observable<TModel> {
        return this.get('Incident/' + incidentId + '/' + this._entityName).pipe(
            map(r => {
                const incident: TModel = this._entityCreator();
                for (const propertyName in r) {
                    incident[propertyName] = r[propertyName];
                }

                return incident;
            }));
    }

    public getIncidents(searchCriteria: IncidentSearchCriteria): Observable<ValidatedResponse<TModel[]>> {
        return this.get('Incident/' + this._entityName + '/Search?' + $.param(searchCriteria));
    }

    public saveIncident(incident: TModel) {
        let model = incident;

        if (null != incident.forTransport) {
            model = incident.forTransport();
        }

        return this.post(`Incident/${this._entityName}`, model, this.replacer).pipe(
            catchError((error) => this.handleError(error)));
    }

    public deleteIncident(incidentNumberId: number) {
        return this.delete('Incident/' + incidentNumberId + '/' + this._entityName);
    }

    protected handleError(error: HttpErrorResponse) {
        if (error.error) {
            return observableThrowError(error.error);
        } else {
            return observableThrowError('Server error');
        }
    }

    protected replacer(key, value) {
        if (value === '') {
            return undefined;
        }
        return value;
    }
}
